module.exports = function() {
  return new Worker(__webpack_public_path__ + "b76eea0990cef4fcedf7.worker.js");
};